import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TGetPartnerUBODocumentParams,
  TGetPartnerUBODocumentResponse,
} from "./getPartnerUBODocument.schema";

export const getPartnerUBODocument = (axios: IAxiosInstance) => {
  return async (
    params: TGetPartnerUBODocumentParams
  ): Promise<TGetPartnerUBODocumentResponse> => {
    const { whiteLabelID, first_name, last_name } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TGetPartnerUBODocumentResponse>
    >(`/api/partners/${whiteLabelID}/ubo-document`, {
      params: { first_name, last_name },
    });
    const resData = response.data;
    if (resData?.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
